module.exports = __webpack_public_path__ + "img/google.1cfb7868.svg";